var map = {
	"./hotel/24-hour-front-desk.svg": "46d8",
	"./hotel/balcony.svg": "d0cb",
	"./hotel/bars.svg": "5816",
	"./hotel/dry-cleaning-service.svg": "92aa",
	"./hotel/fitness-center.svg": "bd1f",
	"./hotel/internet-access.svg": "071a",
	"./hotel/luggage-storage.svg": "370b",
	"./hotel/outdoor-pool.svg": "6c38",
	"./hotel/parking.svg": "406e",
	"./hotel/pets-allowed.svg": "d59b",
	"./hotel/room-service.svg": "686e",
	"./hotel/terrace.svg": "7c7f",
	"./hotel/wifi.svg": "39fa",
	"./room/air-conditioning.svg": "b226",
	"./room/bedding.svg": "25d7",
	"./room/hair-dryer.svg": "d1fc",
	"./room/iron-ironing-board.svg": "0b1a",
	"./room/sqm.svg": "11a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1b7b";